export { MemberScopeTable } from './MemberScopeTable';
